import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mt-5" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Carte VA")
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_5 = { class: "col-12 col-lg-4 m-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "col-lg-4 bg-primary rounded text-light text-start pt-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("u", null, "Attention:")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Une carte VAvantages est déjà enregistrée pour ce compte. Assurez-vous que les informations renseignées soient correctes, et de bénéficier de l'adhésion VAvantages. Si ce n'est pas le cas, vous pouvez cliquer sur Modifier afin de les mettre à jour. ", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "col-lg-4 bg-primary rounded text-light text-start pt-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" La carte VAvantages est une carte délivrée aux étudiants de l'INSA de Lyon. Elle doit être en cours de validité et vous devez bénéficier de l'"),
  /*#__PURE__*/_createElementVNode("strong", null, "adhésion VAvantages"),
  /*#__PURE__*/_createTextVNode(" pour sa validation. Si vous disposez d'une carte VAvantages, assurez-vous que les nom et prénom saisis dans le formulaire d'inscription correspondent bien aux nom et prénom figurant sur votre carte VA. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Le numéro de la carte VAvantages est le numéro commençant par 'c' suivi de 12 chiffres. Il se trouve en-dessous du code-barres sur la carte. ")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_19 = { class: "col col-lg-4 fw-bold text-start" }
const _hoisted_20 = { class: "row m-2 mt-4" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12 my-2 my-lg-0 col-lg form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "inputFirstName" }, "Prénom sur la carte VAvantages: ", -1)
const _hoisted_24 = { class: "col-12 my-2 my-lg-0 col-lg form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "inputLastName" }, "Nom sur la carte VAvantages:", -1)
const _hoisted_26 = { class: "row mt-2" }
const _hoisted_27 = { class: "col form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "inputVA" }, "Numéro de carte VA: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-end" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-success"
    }, " Les informations sont correctes ")
  ])
], -1)
const _hoisted_30 = { class: "row m-2 mt-4" }
const _hoisted_31 = { class: "col text-end" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_33 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_35 = { class: "col col-lg-4 fw-bold text-start" }
const _hoisted_36 = { class: "row m-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "" }, " Avez-vous une carte VA? ", -1)
const _hoisted_38 = { class: "ms-4 mt-2" }
const _hoisted_39 = { class: "form-check" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "yesRadioButton"
}, " Oui ", -1)
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "noRadioButton"
}, " Non ", -1)
const _hoisted_43 = {
  key: 0,
  class: "row m-2 mt-4"
}
const _hoisted_44 = { class: "col text-end" }
const _hoisted_45 = {
  key: 1,
  class: "row m-2 mt-4"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12 my-2 my-lg-0 col-lg form-group" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "inputFirstName" }, "Prénom sur la carte VAvantages: ", -1)
const _hoisted_49 = { class: "col-12 my-2 my-lg-0 col-lg form-group" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "inputLastName" }, "Nom sur la carte VAvantages:", -1)
const _hoisted_51 = { class: "row mt-2" }
const _hoisted_52 = { class: "col form-group" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "inputVA" }, "Numéro de carte VAvantages: ", -1)
const _hoisted_54 = { class: "row mt-5" }
const _hoisted_55 = { class: "col col-lg-6" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-6 text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Valider")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnfoundVa = _resolveComponent("UnfoundVa")!
  const _component_ProblemVa = _resolveComponent("ProblemVa")!
  const _component_StepBar = _resolveComponent("StepBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_UnfoundVa, { onCloseUnfoundModal: _ctx.toggleUnfoundModal }, null, 8, ["onCloseUnfoundModal"]), [
      [_vShow, _ctx.showUnfoundModal]
    ]),
    _withDirectives(_createVNode(_component_ProblemVa, { onCloseProblemModal: _ctx.toggleProblemModal }, null, 8, ["onCloseProblemModal"]), [
      [_vShow, _ctx.showProblemModal]
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_StepBar, { index: 3 })
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_ctx.previousVaExists)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)),
      _hoisted_16
    ]),
    (_ctx.previousVaExists && !_ctx.updatePreviousVa)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendVa && _ctx.sendVa(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vaFirstName) = $event)),
                      type: "text",
                      class: "form-control",
                      id: "inputFirstName",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.vaFirstName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vaLastName) = $event)),
                      type: "text",
                      class: "form-control",
                      id: "inputLastName",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.vaLastName]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("input", {
                      title: "Le numéro de la carte VAvantages est le numéro commençant par 'c' suivi de 12 chiffres. Il se trouve en-dessous du code-barres sur la carte.",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vaNumber) = $event)),
                      type: "text",
                      class: "form-control",
                      pattern: "[c][0-9]{12}",
                      id: "inputVA",
                      placeholder: "c000000000000",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.vaNumber]
                    ])
                  ])
                ])
              ], 32),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toogleUpdateVa && _ctx.toogleUpdateVa(...args)))
                  }, " Modifier ")
                ])
              ])
            ])
          ]),
          _hoisted_32
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "yesRadioButton",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChange($event))),
                    checked: ""
                  }, null, 32),
                  _hoisted_40
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "noRadioButton",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChange($event)))
                  }, null, 32),
                  _hoisted_42
                ])
              ])
            ]),
            (!_ctx.VA)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
                    }, " Continuer ")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.VA)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("form", {
                    onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendVa && _ctx.sendVa(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.vaFirstName) = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputFirstName",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.vaFirstName]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.vaLastName) = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputLastName",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.vaLastName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _withDirectives(_createElementVNode("input", {
                          title: "Le numéro de la carte VAvantages est le numéro commençant par 'c' suivi de 12 chiffres. Il se trouve en-dessous du code-barres sur la carte.",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.vaNumber) = $event)),
                          type: "text",
                          pattern: "[c][0-9]{12}",
                          placeholder: "c000000000000",
                          class: "form-control",
                          id: "inputVA",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.vaNumber]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-secondary",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleProblemModal && _ctx.toggleProblemModal(...args)))
                        }, " J'ai un problème ")
                      ]),
                      _hoisted_56
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_57
        ]))
  ]))
}